import React, { ReactElement } from 'react';
import Modal from '../../../components/modal/modal';
import useLocale from '../../../hooks/use-locale';

type Props = {
    open: boolean;
    onClose(): void;
    onSubmit(): void;
};

export default function DeleteCampaignItemForm(props: Props): ReactElement {
    const { open, onClose, onSubmit } = props;

    const { getText } = useLocale();

    return (
        <Modal
            onClose={onClose}
            title={getText('widgets.campaigns.delete.title')}
            open={open}
            actions={[
                {
                    id: 'delete',
                    label: getText('widgets.campaigns.delete.action'),
                    variant: 'text',
                },
            ]}
            onSubmit={() => onSubmit()}
        >
            <div className='flex flex-col gap-20'>
                <p className='text-xl text-companyDarkGrey'>{getText('widgets.campaigns.delete.content')}</p>
            </div>
        </Modal>
    );
}
